import { useRouter } from "next/router";

import { useDealSelector } from "@redux/reducers/deal";

import { CTA_SOL_TYPES } from "@shared/constants";
import { ROUTES } from "@shared/routing/routes";

export const useIsOnFirstBasketStep = () => {
  const router = useRouter();
  const deal = useDealSelector();

  const isBasketPage = router.pathname === ROUTES.BASKET;
  const isFirstStep = deal.lastCta === CTA_SOL_TYPES.VEHICLE_SELECTED;

  return isBasketPage && isFirstStep;
};
